import { render } from "./carrouselHeader.vue?vue&type=template&id=223a9c04"
import script from "./carrouselHeader.vue?vue&type=script&lang=js"
export * from "./carrouselHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/desarrollo/Documents/Proyectos/friax/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__